import styled from 'styled-components'

export const BadgeMontagemGratisContainer = styled.div`
  border-radius: 0.25rem;
  width: 100%;
  height: auto;
  background: #e3e3e8;
  padding: 0.313rem 0.5rem;
  display: flex;
  align-content: center;
  align-items: center;
  gap: 0.5rem;
`

export const BadgeMontagemGratisImagem = styled.img`
  height: 1.5rem !important;
  width: 1.3rem !important;
`

export const BadgeMontagemGratisMensagem = styled.span`
  font-weight: 700;
  font-size: 0.75rem !important;
  color: #646981;
  margin-top: 0.1px !important;

  .texto-destacado {
    font-size: 0.75rem !important;
    color: #508908 !important;
  }
`
